module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_automotive_sp-5baa783d0f0b3d50f60f5deaba172f03.svg";